import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  const footerLinks = [{
    name: 'Home',
    href: '/'
  }, {
    name: 'Events',
    href: '/events'
  }, {
    name: 'Manifiesto',
    href: '/#manifiesto'
  }, {
    name: 'Join the community',
    href: '/#join'
  }];
  return <footer className="bg-cream border-t border-navy/10 py-16 px-6 md:px-12" data-id="element-51">
      <div className="max-w-7xl mx-auto flex flex-col items-center justify-center gap-8" data-id="element-52">
        <div className="flex flex-col items-center gap-2" data-id="element-53">
          <div className="flex items-center gap-2 font-serif font-bold text-2xl tracking-tight text-navy" data-id="element-54">
            <img src="https://substackcdn.com/image/fetch/w_80,h_80,c_fill,f_webp,q_auto:good,fl_progressive:steep/https%3A%2F%2Fsubstack-post-media.s3.amazonaws.com%2Fpublic%2Fimages%2F160e90df-0a0d-4a89-80fd-69aaa3c16c48_256x256.png" alt="Familiar Spaces door icon" className="h-7 w-auto object-contain" data-id="element-55" />
            familiar spaces
          </div>
          <p className="text-sm text-navy/60 font-light" data-id="element-56">
            An initiative by Reurbano.
          </p>
        </div>

        <nav className="flex flex-wrap justify-center gap-6 md:gap-10" data-id="element-57">
          {footerLinks.map(link => <Link key={link.name} to={link.href} className="text-sm font-medium text-navy/70 hover:text-navy transition-colors" data-id="element-58">
              {link.name}
            </Link>)}
        </nav>
      </div>
    </footer>;
}